import { Button } from 'components/atoms';
import React from 'react';

import css from './AuszugAtButton.module.scss';
import AuszugAtIcon from './AuszugAtIcon';

interface AuszugAtButtonProps 
{
  text: string;
}

const AuszugAtButton: React.FC<AuszugAtButtonProps> = (props) =>
{

  return (
    <div className={css.button}>
    <Button variant="secondary">
      {props.text}
      <div className={css.logo}><AuszugAtIcon/></div>
    </Button>
    </div>
  );
};

export default AuszugAtButton;
